/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetFloorplans200ResponseInnerTablesInner
 */
export interface GetFloorplans200ResponseInnerTablesInner {
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    x: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    y: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    height: number;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    max: number;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    zone: string;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    terraceSurchargePercentage: number;
    /**
     * 
     * @type {number}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    flatFeeSurcharge?: number;
    /**
     * 
     * @type {string}
     * @memberof GetFloorplans200ResponseInnerTablesInner
     */
    surchargeType: string;
}

/**
 * Check if a given object implements the GetFloorplans200ResponseInnerTablesInner interface.
 */
export function instanceOfGetFloorplans200ResponseInnerTablesInner(value: object): value is GetFloorplans200ResponseInnerTablesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('terraceSurchargePercentage' in value) || value['terraceSurchargePercentage'] === undefined) return false;
    if (!('surchargeType' in value) || value['surchargeType'] === undefined) return false;
    return true;
}

export function GetFloorplans200ResponseInnerTablesInnerFromJSON(json: any): GetFloorplans200ResponseInnerTablesInner {
    return GetFloorplans200ResponseInnerTablesInnerFromJSONTyped(json, false);
}

export function GetFloorplans200ResponseInnerTablesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFloorplans200ResponseInnerTablesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'x': json['x'],
        'y': json['y'],
        'width': json['width'],
        'height': json['height'],
        'type': json['type'],
        'min': json['min'],
        'max': json['max'],
        'zone': json['zone'],
        'terraceSurchargePercentage': json['terraceSurchargePercentage'],
        'flatFeeSurcharge': json['flatFeeSurcharge'] == null ? undefined : json['flatFeeSurcharge'],
        'surchargeType': json['surchargeType'],
    };
}

export function GetFloorplans200ResponseInnerTablesInnerToJSON(json: any): GetFloorplans200ResponseInnerTablesInner {
    return GetFloorplans200ResponseInnerTablesInnerToJSONTyped(json, false);
}

export function GetFloorplans200ResponseInnerTablesInnerToJSONTyped(value?: GetFloorplans200ResponseInnerTablesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'x': value['x'],
        'y': value['y'],
        'width': value['width'],
        'height': value['height'],
        'type': value['type'],
        'min': value['min'],
        'max': value['max'],
        'zone': value['zone'],
        'terraceSurchargePercentage': value['terraceSurchargePercentage'],
        'flatFeeSurcharge': value['flatFeeSurcharge'],
        'surchargeType': value['surchargeType'],
    };
}

